import { Tabs } from "antd"
import BookingTab from "./BookingTab"
import EmailsTab from "./EmailsTab"
import MessagesTab from "./MessagesTab"
import TextsTab from "./TextsTab"
import styles from "./index.module.css"

import { useState, useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"
import { usePermissions } from "hooks/usePermissions"
import { MODULES } from "utils/permissions"

const ClientDetailsTabs = () => {
  const { id } = useParams()
  const location = useLocation()
  const { activeTab } = location.state || {}
  const [activeKey, setActiveKey] = useState("1")
  const { hasModuleAccess } = usePermissions()
  const hasMessagesAccess = hasModuleAccess(MODULES.MESSAGES)

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "email") {
        setActiveKey("2")
      } else if (activeTab === "text") {
        setActiveKey("4")
      }
    }
  }, [activeTab])

  const allItems = [
    {
      key: "1",
      label: "Bookings",
      children: <BookingTab active={activeKey === "1"} id={id} />
    },
    {
      key: "2",
      label: "Emails",
      children: <EmailsTab active={activeKey === "2"} id={id} />
    },
    {
      key: "3",
      label: "Messages",
      children: <MessagesTab active={activeKey === "3"} id={id} />,
      show: hasMessagesAccess
    },
    {
      key: "4",
      label: "Texts",
      children: <TextsTab active={activeKey === "4"} id={id} />
    }
  ]

  const items = allItems.filter((item) => item.show !== false)

  return <Tabs className={styles.clientDetailsTabs} defaultActiveKey="1" activeKey={activeKey} onChange={setActiveKey} items={items} />
}

export default ClientDetailsTabs
